import Vuex from 'vuex';
import Vue from 'vue';
import ordersModule from './modules/orders';
import userModule from './modules/user';
import weeklyMenuModule from './modules/weeklyMenu';
import officesModule from './modules/offices';
import companiesModule from './modules/companies';
import dietsModule from './modules/diets';
import eventsModule from './modules/events';
import globalModule from './modules/global';
import allergiesModule from './modules/allergies';
import cateringModule from './modules/catering';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    orders: ordersModule,
    user: userModule,
    weeklyMenu: weeklyMenuModule,
    offices: officesModule,
    companies: companiesModule,
    diets: dietsModule,
    events: eventsModule,
    global: globalModule,
    allergies: allergiesModule,
    catering: cateringModule,
  },
});



// WEBPACK FOOTER //
// ./store/index.js